
export const increaseCartCount = (payload)=>({
    type:"INCREMENT",
    payload
})

export const decreaseCartCount = (payload)=>({
    type:"DECREMENT",
    payload
})